import { localStorageHelpers } from "../../app/helpers/localStorageHelpers";
import { User } from "./types";

export const login = ({ id, token, roles, subjectId }: User, returnUrl = "/") => {
  localStorageHelpers.setUserInfo(id, token, true, roles, subjectId);
  window.location.href = returnUrl;
};
